export const outcomeTitleSelector = (
  outcome: string,
  outcomeTexts: GatsbyTypes.ContentfulOutcomes,
) => {
  switch (outcome) {
    case 'favorable':
      return { title: outcomeTexts.positive, text: outcomeTexts.positiveText };
    case 'non-favorable':
      return { title: outcomeTexts.negative, text: outcomeTexts.negativeText };
    case 'neutral':
      return { title: outcomeTexts.neutral, text: outcomeTexts.neutralText };
    default:
      return { title: '', text: '' };
  }
};

export const totalOutcomeTitleSelector = (
  outcome: string,
  outcomeTitles: GatsbyTypes.ContentfulOutcomes,
) => {
  switch (outcome) {
    case 'favorable':
      return outcomeTitles.positive;
    case 'non-favorable':
      return outcomeTitles.negative;
    case 'neutral':
      return outcomeTitles.neutral;
    default:
      return '';
  }
};
